export default "__VITE_ASSET__18F8pkA5__"